import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../components/shared/table/pagination/Pagination';
import { nextRatesPageAction, prevRatesPageAction, setRatesPageSizeAction } from '../../redux/actions/ratesActions';

const RatesPagination = () => {
  const pageable = useSelector((state) => state.rates?.pageable);
  return (
    <Pagination
      pageable={pageable}
      onNextPageClickAction={nextRatesPageAction}
      onPrevPageClickAction={prevRatesPageAction}
      onPageSizeChangeAction={setRatesPageSizeAction}
    />
  );
};

export default RatesPagination;
